import React, { useEffect, useState } from 'react';
import "./TermoCompromisso.css";
import { useLocation } from 'react-router-dom';
import Navbar from '../../../components/layout/Navbar/Navbar';
import Header from '../../../components/layout/header/Header';
import TermoCompromissoContent from '../../../components/Termo-Compromisso/TermoCompromissoContent';
import Sidebar from '../../../components/layout/Sidebar/Sidebar';
import { getCargoIdSidebar } from '../../../constants/sidebarConfig';
import apiService from '../../../services/api';
import statistics from '../../../assets/statistics.png';

const TermoCompromisso = () => {
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();
  const pendingOnly = location.pathname === '/TermoCompromissoPendentes';

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        setUser(userData);
        setSidebarItems(getCargoIdSidebar(userData.cargoId) || []);
      } catch (err) {
        console.error('Erro ao buscar usuário:', err);
      }
    };

    fetchUser();
  }, []);

  return (
    <div className="TermoCompromisso-Page">
      <div className="TermoCompromisso-navbar">
        <Navbar
          onLogout={apiService.logout}
          showHome={true}
          showNotifications={true}
          showProfile={true}
          showLogout={true}
          user={user}
        />
      </div>
      <div className="TermoCompromisso-container">
        <div className="TermoCompromisso-sidebar">
          <Sidebar items={sidebarItems} />
        </div>
        <div className="TermoCompromisso-main-content">
          <Header
            prefixText="TERMO DE COMPROMISSO DE ESTÁGIO"
            icon={statistics}
            filtrar
            ordenar
            search
            searchValue={searchTerm}
            onSearchChange={setSearchTerm}
          />
          {user && (
            <div className="TermoCompromisso-description-bar">
              {[2, 3].includes(Number(user.cargoId))
                ? 'Faça o download do Termo de Compromisso, providencie as assinaturas necessárias e, em seguida, envie o documento assinado pelo sistema.'
                : 'Os termos de compromisso são assinados e enviados ao sistema pelos coordenadores de curso'}
            </div>
          )}
          {user && (
            <TermoCompromissoContent
              searchTerm={searchTerm}
              pendingOnly={pendingOnly}
              user={user}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TermoCompromisso;
